import { RoutingKey } from '@swf/core/enums';
import type { InviteLink } from '@swf/core/types/Poker';

interface Routes {
  [key: string]: string;
}

interface InviteOptions {
  type: InviteLink;
  [name: string]: unknown;
}

export const createInviteUrl = (
  routes: Routes | undefined,
  { type, ...options }: InviteOptions
) => {
  const args = btoa(JSON.stringify({ type, ...options }));

  return `${window.location.origin}${routes?.[RoutingKey.HomeGamesInvite]}?args=${args}`;
};
